/**** WARNING: This is a generated file, so any changes might get overwritten! ****/
const _t = (window as any).vvTranslations?.ActionForm || {};
export * from './Common.ts';
export const First_Name_Label = (): string => _t.First_Name_Label ?? "First name";
export const Last_Name_Label = (): string => _t.Last_Name_Label ?? "Last name";
export const Email_Label = (): string => _t.Email_Label ?? "Email";
export const Phone_Label = (): string => _t.Phone_Label ?? "Phone";
export const Fax_Label = (): string => _t.Fax_Label ?? "Fax";
export const Mobile_Number_Label = (): string => _t.Mobile_Number_Label ?? "Mobile Number";
export const Honorific_Label = (): string => _t.Honorific_Label ?? "Prefix";
export const Suffix_Label = (): string => _t.Suffix_Label ?? "Suffix";
export const Street_Address_Label = (): string => _t.Street_Address_Label ?? "Street Address";
export const City_Label = (): string => _t.City_Label ?? "City";
export const State_Label = (): string => _t.State_Label ?? "State";
export const Zip_Code_Label = (): string => _t.Zip_Code_Label ?? "ZIP Code";
export const Company_Name_Label = (): string => _t.Company_Name_Label ?? "Company Name";
export const Title_Label = (): string => _t.Title_Label ?? "Title";
export const Home_Address_Section = (): string => _t.Home_Address_Section ?? "Home Address";
export const Business_Section = (): string => _t.Business_Section ?? "Business Information";
export const Business_Address_Section = (): string => _t.Business_Address_Section ?? "Business Address";
export const First_Name_Required = (): string => _t.First_Name_Required ?? "First name is required";
export const Last_Name_Required = (): string => _t.Last_Name_Required ?? "Last name is required";
export const Email_Required = (): string => _t.Email_Required ?? "Email is required";
export const Email_Invalid = (): string => _t.Email_Invalid ?? "Please enter a valid email";
export const Phone_Required = (): string => _t.Phone_Required ?? "Phone number is required";
export const Phone_Invalid = (): string => _t.Phone_Invalid ?? "Please enter a valid phone number";
export const Mobile_Required = (): string => _t.Mobile_Required ?? "Mobile number is required for text messages";
export const Mobile_Invalid = (): string => _t.Mobile_Invalid ?? "Please enter a valid mobile number";
export const Mobile_Not_Mobile = (): string => _t.Mobile_Not_Mobile ?? "Please enter a valid mobile phone number.";
export const Street_Required = (): string => _t.Street_Required ?? "Street address is required";
export const City_Required = (): string => _t.City_Required ?? "City is required";
export const State_Required = (): string => _t.State_Required ?? "State is required";
export const Zip_Required = (): string => _t.Zip_Required ?? "ZIP code is required";
export const Company_Required = (): string => _t.Company_Required ?? "Company name is required";
export const Title_Required = (): string => _t.Title_Required ?? "Title is required";
export const Address_Invalid = (): string => _t.Address_Invalid ?? "Please enter a valid address";
export const Address_Not_Found = (): string => _t.Address_Not_Found ?? "Sorry! We can't find that address.";
export const Address_Validation_Error = (): string => _t.Address_Validation_Error ?? "Unable to validate address. Please verify your entry.";
export const Address_Multiple_Found = (): string => _t.Address_Multiple_Found ?? "Multiple addresses found. Please select one:";
export const Business_Street_Required = (): string => _t.Business_Street_Required ?? "Business street address is required";
export const Business_City_Required = (): string => _t.Business_City_Required ?? "Business city is required";
export const Business_State_Required = (): string => _t.Business_State_Required ?? "Business state is required";
export const Business_Zip_Required = (): string => _t.Business_Zip_Required ?? "Business ZIP code is required";
export const Business_Address_Invalid = (): string => _t.Business_Address_Invalid ?? "Please enter a valid business address";
export const First_Name_Placeholder = (): string => _t.First_Name_Placeholder ?? "John";
export const Last_Name_Placeholder = (): string => _t.Last_Name_Placeholder ?? "Smith";
export const Email_Placeholder = (): string => _t.Email_Placeholder ?? "john.smith@email.com";
export const Phone_Placeholder = (): string => _t.Phone_Placeholder ?? "(555) 123-4567";
export const Fax_Placeholder = (): string => _t.Fax_Placeholder ?? "(555) 123-4568";
export const Mobile_Placeholder = (): string => _t.Mobile_Placeholder ?? "(555) 123-4567";
export const Suffix_Placeholder = (): string => _t.Suffix_Placeholder ?? "Jr., Sr., etc.";
export const Street_Placeholder = (): string => _t.Street_Placeholder ?? "123 Main Street";
export const Zip_Placeholder = (): string => _t.Zip_Placeholder ?? "62701";
export const Company_Placeholder = (): string => _t.Company_Placeholder ?? "Acme Corp";
export const Title_Placeholder = (): string => _t.Title_Placeholder ?? "Manager";
export const Text_Subscribe_Label = (): string => _t.Text_Subscribe_Label ?? "Yes, sign me up to receive text alerts";
export const Remember_Me_Checkbox_Label = (): string => _t.Remember_Me_Checkbox_Label ?? "Remember my information for future actions";
export const Address_Verified = (): string => _t.Address_Verified ?? "Address verified";
export const Verifying_Address = (): string => _t.Verifying_Address ?? "Verifying...";
export const Welcome_Back = (): string => _t.Welcome_Back ?? "Welcome back!";
export const Continue_As = (name: string): string => {
  const override: string = _t.Continue_As;
  const args = {name};
  const msg: string =
    override ? replaceParameters(override, args) 
    : `Sign as ${name}`;
  return msg;
}
;
export const Edit_Info = (): string => _t.Edit_Info ?? "Edit info";
export const Not_Me = (): string => _t.Not_Me ?? "Not me";
export const Resubscribe_Text_Warning = (phoneNumber: string): string => {
  const override: string = _t.Resubscribe_Text_Warning;
  const args = {phoneNumber};
  const msg: string =
    override ? replaceParameters(override, args) 
    : `You must text "START" to ${phoneNumber} because you previously un-subscribed.`;
  return msg;
}
;
